import React, { Component } from 'react'
import Fragment from 'react-dot-fragment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { track } from 'app/modules/tracking/actions'
import { fetchUserProperties, updateUserPropertiesTheRightWay } from 'app/modules/user/properties/actions'
import { properties as userProperties } from 'app/modules/user/properties/selectors'
import { FeatureTooltip } from '@driftt/tide-tooltips-legacy'
import { Icon } from '@driftt/tide-core-legacy'
import eduVideo from 'images/marketo-video.png'

import './style.styl'

const MARKETO_EDU_URL = 'https://insider.drift.com/lessons/marketo-and-drift/'

function mapStateToProps(state) {
  return {
    hasSeenEduNudge: userProperties(state).get('hasSeenMarketoEduNudge') || false
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchUserProperties,
      updateUserProperties: updateUserPropertiesTheRightWay,
      track,
    }, dispatch)
  }
}

class MarketoEduTooltip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showEduNudgeTimed: false,
      showEduTooltip: false,
    }
  }

  componentDidMount = () => {
    this.props.actions.fetchUserProperties()
    setTimeout(() => {
      this.setState({ showEduNudgeTimed: true })
      this.props.actions.track("In App Education - Viewed", { page: "marketo", nudge: !this.props.hasSeenEduNudge })
    }, 5000)
  }

  componentWillUnmount = () => {
    this.updateUserProps()
  }

  updateUserProps = () => {
    if (!this.props.hasSeenEduNudge) {
      this.props.actions.updateUserProperties({ hasSeenMarketoEduNudge: true }, false)
    }
  }

  onToggleEduTooltip = () => {
    const { showEduTooltip } = this.state
    if (!!showEduTooltip) {
      this.updateUserProps()
      this.props.actions.track("In App Education - Closed", { page: "marketo", nudge: !this.props.hasSeenEduNudge })
    } else {
      this.props.actions.track("In App Education - Opened", { page: "marketo", nudge: !this.props.hasSeenEduNudge })
    }
    this.setState({ showEduTooltip: !showEduTooltip, showEduNudgeTimed: false })
  }

  onWatchEduTooltip = (link) => {
    window.open(MARKETO_EDU_URL, '_blank')
    this.props.actions.track("In App Education - Watched", { page: "marketo", nudge: !this.props.hasSeenEduNudge, link: link })
    this.setState({ showEduTooltip: false })
  }

  render() {
    const {
      showEduNudgeTimed,
      showEduTooltip,
    } = this.state

    const { hasSeenEduNudge } = this.props

    return (
      <div className="marketo-integration-edu-nudge-animation-container">
        {!!showEduNudgeTimed && !hasSeenEduNudge &&
          <Fragment>
            <Icon className="marketo-integration-edu-nudge-bolt" name="lightning-bolt-filled" />
            <Icon className="marketo-integration-edu-nudge-bolt" name="lightning-bolt-filled" />
            <Icon className="marketo-integration-edu-nudge-bolt" name="lightning-bolt-filled" />
            <Icon className="marketo-integration-edu-nudge-bolt" name="lightning-bolt-filled" />
            <Icon className="marketo-integration-edu-nudge-bolt" name="lightning-bolt-filled" />
          </Fragment>
        }
        <FeatureTooltip
          className="marketo-integration-edu-tooltip"
          onClose={() => this.onToggleEduTooltip()}
          showTooltip={!!showEduTooltip}
          ribbonType="how"
          orientation="vertical"
          tooltipSide="bottom"
          tooltipCaretLocation="center"
          headerCopy="Learn how to set up your Marketo integration"
          bodyCopy="Sync data and use munchkin cookies to target and personalize your site visitors’ experience!"
          mediaComponent={
            <div>
              <img className={"marketo-integration-edu-tooltip-img"} src={eduVideo} onClick={() => { this.onWatchEduTooltip("img") }} alt="Marketo how-to video" />
            </div>
          }
          buttonInfoArray={[
            {
              copy: 'Watch on Drift Insider',
              func: () => {
                this.onWatchEduTooltip("button")
              },
            }
          ]}>
          <div className="marketo-integration-edu-tooltip-container" onClick={this.onToggleEduTooltip}>
            <Icon className="marketo-integration-edu-nudge-icon" name="video-play" />
            <span className="marketo-integration-edu-nudge-copy">How to set up Marketo</span>
          </div>
        </FeatureTooltip>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketoEduTooltip)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/MarketoEduTooltip/index.js